import React from 'react';
import '../../../styles/CampaignWizard.css';

const CampaignInfo = ({ campaign, onChange }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    onChange(name, value);
  };
  
  return (
    <div className="wizard-step-container">
      <div className="wizard-step-header">
        <h2>Campaign Information</h2>
        <p>Give your campaign a name and description to help you identify it later.</p>
      </div>
      
      <div className="form-container">
        <div className="form-group">
          <label htmlFor="name">Campaign Name *</label>
          <input
            type="text"
            id="name"
            name="name"
            value={campaign.name}
            onChange={handleChange}
            placeholder="e.g., Spring Promotion 2025"
            required
          />
          <div className="form-hint">Choose a descriptive name for your campaign</div>
        </div>
        
        <div className="form-group">
          <label htmlFor="description">Campaign Description</label>
          <textarea
            id="description"
            name="description"
            value={campaign.description}
            onChange={handleChange}
            placeholder="Describe the purpose of this campaign..."
            rows="4"
          ></textarea>
          <div className="form-hint">Optional: Add details about the campaign's goals, target audience, etc.</div>
        </div>
        
        <div className="form-group">
          <label>Campaign Type</label>
          <div className="radio-group">
            <div className="radio-option">
              <input
                type="radio"
                id="type-regular"
                name="campaignType"
                value="regular"
                checked={campaign.campaignType === 'regular' || !campaign.campaignType}
                onChange={() => onChange('campaignType', 'regular')}
              />
              <label htmlFor="type-regular" className="radio-label">
                <div className="radio-title">Regular Campaign</div>
                <div className="radio-description">Send a sequence of emails with a fixed schedule</div>
              </label>
            </div>
            
            <div className="radio-option">
              <input
                type="radio"
                id="type-drip"
                name="campaignType"
                value="drip"
                checked={campaign.campaignType === 'drip'}
                onChange={() => onChange('campaignType', 'drip')}
              />
              <label htmlFor="type-drip" className="radio-label">
                <div className="radio-title">Drip Campaign</div>
                <div className="radio-description">Send emails based on user actions and triggers</div>
              </label>
            </div>
          </div>
        </div>
        
        <div className="form-group">
          <label>Tags</label>
          <input
            type="text"
            name="tags"
            value={campaign.tags || ''}
            onChange={handleChange}
            placeholder="e.g., promotion, newsletter, follow-up"
          />
          <div className="form-hint">Optional: Add comma-separated tags to help organize your campaigns</div>
        </div>
      </div>
      
      <div className="form-section">
        <h3>Campaign Goals</h3>
        <p>Define what you want to achieve with this campaign.</p>
        
        <div className="form-group">
          <label>Primary Goal</label>
          <select
            name="primaryGoal"
            value={campaign.primaryGoal || ''}
            onChange={handleChange}
          >
            <option value="">Select a primary goal</option>
            <option value="awareness">Awareness - Introduce your product/service</option>
            <option value="engagement">Engagement - Increase interaction with your brand</option>
            <option value="conversion">Conversion - Generate sales or sign-ups</option>
            <option value="retention">Retention - Keep existing customers engaged</option>
            <option value="feedback">Feedback - Collect customer opinions</option>
            <option value="other">Other</option>
          </select>
        </div>
        
        {campaign.primaryGoal === 'other' && (
          <div className="form-group">
            <label>Custom Goal</label>
            <input
              type="text"
              name="customGoal"
              value={campaign.customGoal || ''}
              onChange={handleChange}
              placeholder="Describe your custom goal..."
            />
          </div>
        )}
        
        <div className="form-group">
          <label>Target Metrics</label>
          <div className="metrics-container">
            <div className="metric-input">
              <label>Open Rate Target (%)</label>
              <input
                type="number"
                name="openRateTarget"
                min="0"
                max="100"
                value={campaign.openRateTarget || ''}
                onChange={handleChange}
                placeholder="e.g., 25"
              />
            </div>
            
            <div className="metric-input">
              <label>Click Rate Target (%)</label>
              <input
                type="number"
                name="clickRateTarget"
                min="0"
                max="100"
                value={campaign.clickRateTarget || ''}
                onChange={handleChange}
                placeholder="e.g., 5"
              />
            </div>
            
            <div className="metric-input">
              <label>Reply Rate Target (%)</label>
              <input
                type="number"
                name="replyRateTarget"
                min="0"
                max="100"
                value={campaign.replyRateTarget || ''}
                onChange={handleChange}
                placeholder="e.g., 10"
              />
            </div>
          </div>
          <div className="form-hint">Optional: Set target metrics to measure your campaign's success</div>
        </div>
      </div>
    </div>
  );
};

export default CampaignInfo;